import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const planColumns: GridColumnConfig[] = [
  {
    title: 'Plan (File) Name',
    field: 'planName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'File Type',
    field: 'planFileTypeName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Customer Name',
    field: 'customerName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Office(s)',
    field: 'officeName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Associated Plan (File) Name',
    field: 'associatedPlanName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Download Files',
    field: 'fileName',
    filter: 'text',
    searchable: false,
    isGroupable: false,
    isHideColumnMenu: true
  },
  {
    title: 'Status',
    field: 'planStatus',
    filter: 'boolean',
    searchable: true,
  },
];
